import { useQuery } from '@apollo/client';
import React, { useEffect, useState } from 'react';
import { withRouter, RouteComponentProps, useParams } from 'react-router-dom';
import { capitaliseFirst, pluralise } from '../../../../../../utils/stringUtils';

import Dashboard from '../../../../../../layouts/Dashboard';
import { EditCategoryItem } from '../../../../../../components/Global/CategoryItem';

import { editCategoryItemInitQuery, CategoryItem, Location } from './queries';

interface Props extends RouteComponentProps {}

interface UrlParams {
  menu_id: string;
  category_type: string;
  category_id: string;
  item_id: string;
}

const EditItemOrg = ({ history }: Props): React.ReactElement => {
  const { menu_id, category_type, category_id, item_id } = useParams<UrlParams>();
  const categoryType = capitaliseFirst(category_type);

  const [location, setLocation] = useState<Location>({
    name: '',
    currency: '',
    locale: '',
    tax_rate: 0,
    organisation_id: '',
  });

  const [categoryItem, setCategoryItem] = useState<CategoryItem>({
    name: '',
    category_assignments: [
      {
        category: {
          name: '',
          menu: {
            name: '',
          },
        },
      },
    ],
  });

  const { data: editCategoryItemInitData } = useQuery(editCategoryItemInitQuery(item_id, category_type), { fetchPolicy: 'no-cache' });

  useEffect(() => {
    let mounted = true;
    if (mounted && editCategoryItemInitData) {
      setCategoryItem(editCategoryItemInitData[`${pluralise(category_type, 2)}_by_pk`]);
      setLocation(editCategoryItemInitData.locations[0]);
    }
    return () => {
      mounted = false;
    };
  }, [category_type, editCategoryItemInitData]);

  const handleFinish = () => {
    history.push(`/loc/menus/${menu_id}/${category_type}/categories/${category_id}`);
  };

  return (
    <>
      <Dashboard
        breadcrumbs={[
          { label: 'Menus', link: `/loc/menus` },
          { label: categoryItem.category_assignments[0].category.menu.name, link: `/loc/menus/${menu_id}` },
          { label: `${categoryType} Categories` },
          { label: categoryItem.category_assignments[0].category.name, link: `/loc/menus/${menu_id}/${category_type}/categories/${category_id}` },
          { label: categoryItem.name },
          { label: 'Edit' },
        ]}>
        {location.tax_rate && (
          <EditCategoryItem
            item_id={item_id}
            category_type={category_type}
            organisation_id={location.organisation_id}
            category_id={category_id}
            currency={location.currency}
            locale={location.locale}
            taxRate={location.tax_rate}
            handleFinish={handleFinish}
          />
        )}
      </Dashboard>
    </>
  );
};

export default withRouter(EditItemOrg);
